import $ from 'jquery'; // Using jQuery as frontend.js uses it heavily
import { BookingStateManager } from './state';
import { renderCalendar, fetchAvailableDates } from './calendar';
import { fetchAvailability, updateSelectedBookingInfo, showFormView } from './slots';
import { initTimezones, disableTimezoneSelection } from './timezones';
import { delegateEvent } from './utils';
class BookACallAccordion {
    constructor() {
        this.experts = [];
        this.init();
    }
    init() {
        const expertElements = document.querySelectorAll('.expert-booking-content');
        if (!expertElements.length)
            return;
        expertElements.forEach(el => {
            const expertId = parseInt(el.dataset.expertId);
            const email = el.dataset.expertEmail;
            const meetingDuration = parseInt(el.dataset.meetingDuration);
            this.experts.push({
                id: expertId,
                email: email,
                meeting_duration: meetingDuration
            });
        });
        this.stateManager = new BookingStateManager(this.experts);
        this.bindEvents();
    }
    bindEvents() {
        $(document).on('click', '.expert-booking-trigger', (e) => {
            const $trigger = $(e.currentTarget);
            const contentId = $trigger.attr('aria-controls');
            const $content = $(`#${contentId}`);
            const expertId = parseInt($content.data('expert-id'));
            if (expertId) {
                this.initExpertBooking(expertId, $content[0]);
            }
        });
        delegateEvent(document.body, 'change', '.timezone-select', (e, target) => {
            const expertId = parseInt(target.dataset.expertId);
            const state = this.stateManager.getExpertState(expertId);
            state.timezone = target.value;
            state.date = null;
            state.time = null;
            const rootEl = target.closest('.expert-booking-content');
            const calendarContainer = (rootEl ? rootEl.querySelector(`#booking-calendar-${expertId}`) : null) || document.querySelector(`#booking-calendar-${expertId}`);
            if (calendarContainer) {
                calendarContainer.innerHTML = '<div class="calendar-loading">Loading...</div>';
                calendarContainer.classList.remove('loaded');
            }
            const slotsContainer = (rootEl ? rootEl.querySelector(`#booking-slots-${expertId}`) : null) || document.querySelector(`#booking-slots-${expertId}`);
            if (slotsContainer)
                slotsContainer.style.display = 'none';
            // Re-fetch and render (must fetch first, then render)
            fetchAvailableDates(this, expertId, rootEl).then(() => {
                renderCalendar(this, expertId, state.currentDate, rootEl);
            });
        });
        delegateEvent(document.body, 'click', '.time-slot:not(.unavailable)', (e, target) => {
            const rootEl = target.closest('.expert-booking-content');
            this.selectTime(parseInt(target.dataset.expertId), target.dataset.time, rootEl);
        });
        delegateEvent(document.body, 'keydown', '.time-slot:not(.unavailable)', (e, target) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const rootEl = target.closest('.expert-booking-content');
                this.selectTime(parseInt(target.dataset.expertId), target.dataset.time, rootEl);
            }
        });
        delegateEvent(document.body, 'change', '.slots-select', (e, target) => {
            const expertId = target.dataset.expertId || target.getAttribute('data-expert-id');
            const rootEl = target.closest('.expert-booking-content');
            if (expertId) {
                this.selectTime(parseInt(expertId), target.value, rootEl);
            }
            else {
                const slotsContainer = target.closest('.slots-container');
                if (slotsContainer && slotsContainer.dataset.expertId) {
                    this.selectTime(parseInt(slotsContainer.dataset.expertId), target.value, rootEl);
                }
            }
        });
        $(document).on('properFormSubmitSuccess', (e, formData, response) => {
            const form = e.target;
            if (!form)
                return;
            const expertId = parseInt(form.getAttribute('data-expert-id'));
            if (!expertId)
                return;
            const formWrapper = document.getElementById(`form-wrapper-${expertId}`);
            const successMessage = document.getElementById(`success-message-${expertId}`);
            if (formWrapper && successMessage) {
                formWrapper.querySelector('.proper-form-wrapper').style.display = 'none';
                formWrapper.querySelector('.back-to-selection').style.display = 'none';
                successMessage.style.display = 'block';
            }
        });
        delegateEvent(document.body, 'click', '.btn-add-calendar', (e, target) => {
            const expertIdAttr = target.id.replace('add-to-calendar-', '');
            const expertId = parseInt(expertIdAttr);
            const state = this.stateManager.getExpertState(expertId);
            if (state && state.date && state.time) {
                alert(`Meeting scheduled for ${state.date} at ${state.time}. Check your email for calendar invitation.`);
            }
            else {
                alert("Meeting confirmed. Check your email for calendar invitation.");
            }
        });
    }
    initExpertBooking(expertId, rootEl) {
        const state = this.stateManager.getExpertState(expertId);
        const timezoneSelects = (rootEl ? rootEl.querySelectorAll(`[id="booking-timezone-${expertId}"]`) : null) || document.querySelectorAll(`[id="booking-timezone-${expertId}"]`);
        timezoneSelects.forEach(timezoneSelect => {
            if (timezoneSelect && timezoneSelect.options.length === 0) {
                initTimezones(timezoneSelect, state, (newTz) => { });
            }
        });
        this.initTimezoneDropdown(expertId, rootEl);
        const calendarContainers = (rootEl ? rootEl.querySelectorAll(`[id="booking-calendar-${expertId}"]`) : null) || document.querySelectorAll(`[id="booking-calendar-${expertId}"]`);
        calendarContainers.forEach(calendarContainer => {
            if (calendarContainer && (!calendarContainer.classList.contains('loaded') || calendarContainer.querySelector('.calendar-loading'))) {
                import('./calendar').then(({ fetchAvailableDates, renderCalendar }) => {
                    if (state.availableDates && state.availableDates.length > 0) {
                        renderCalendar(this, expertId, state.currentDate, rootEl);
                    }
                    else {
                        fetchAvailableDates(this, expertId, rootEl).then(() => {
                            renderCalendar(this, expertId, state.currentDate, rootEl);
                        });
                    }
                });
            }
        });
    }
    initTimezoneDropdown(expertId, rootEl) {
        const wrappers = (rootEl ? rootEl.querySelectorAll(`.timezone-select-wrapper[data-expert-id="${expertId}"]`) : []);
        wrappers.forEach(wrapper => {
            if (!wrapper || wrapper.dataset.bound)
                return;
            const trigger = wrapper.querySelector('.timezone-trigger');
            const menu = wrapper.querySelector('.timezone-menu');
            const labelEl = wrapper.querySelector('.timezone-selected-label');
            const timezoneSelect = wrapper.querySelector(`#booking-timezone-${expertId}`);
            if (!trigger || !menu || !labelEl || !timezoneSelect)
                return;
            const rebuildMenu = () => {
                menu.innerHTML = '';
                Array.from(timezoneSelect.options).forEach((opt) => {
                    const li = document.createElement('li');
                    li.setAttribute('role', 'option');
                    li.dataset.value = opt.value;
                    li.textContent = opt.textContent || opt.value;
                    if (opt.selected)
                        li.setAttribute('aria-selected', 'true');
                    menu.appendChild(li);
                });
            };
            rebuildMenu();
            const updateLabel = () => {
                const selected = timezoneSelect.options[timezoneSelect.selectedIndex];
                labelEl.textContent = selected ? (selected.textContent || selected.value) : '';
            };
            updateLabel();
            const openMenu = () => {
                menu.hidden = false;
                trigger.setAttribute('aria-expanded', 'true');
            };
            const closeMenu = () => {
                menu.hidden = true;
                trigger.setAttribute('aria-expanded', 'false');
            };
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                const expanded = trigger.getAttribute('aria-expanded') === 'true';
                if (expanded)
                    closeMenu();
                else
                    openMenu();
            });
            menu.addEventListener('click', (e) => {
                const li = e.target.closest('li[role="option"]');
                if (!li)
                    return;
                const value = li.dataset.value;
                timezoneSelect.value = value;
                timezoneSelect.dispatchEvent(new Event('change', { bubbles: true }));
                updateLabel();
                closeMenu();
            });
            document.addEventListener('click', (e) => {
                if (!wrapper.contains(e.target))
                    closeMenu();
            });
            wrapper.dataset.bound = 'true';
        });
    }
    selectDate(expertId, dateStr, rootEl) {
        const state = this.stateManager.getExpertState(expertId);
        state.date = dateStr;
        state.time = null;
        renderCalendar(this, expertId, state.currentDate, rootEl);
        fetchAvailability(this, expertId, rootEl);
    }
    selectTime(expertId, timeValue, rootEl) {
        if (!timeValue)
            return;
        const state = this.stateManager.getExpertState(expertId);
        state.time = timeValue;
        updateSelectedBookingInfo(this, expertId, rootEl);
        showFormView(this, expertId, rootEl);
    }
}
$(document).ready(() => {
    window.bookACallAccordion = new BookACallAccordion();
});
